import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import ActionsBlock from './ActionsBlock';
import * as MessageOutgoingSelectors from '../../../../redux/reducers/message_outgoing_reducer/selectors';
import { useDispatch } from 'react-redux';
import MessageOutgoingActions from '../../../../redux/reducers/message_outgoing_reducer/actions';
import useStyles from './styles';
import Filter from '../filter';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';
import useQuery from 'custom_hooks/useQuery';
import { Box } from '@material-ui/core';
import { parseQueryDate } from '../../../../utils/dates';

export default function DatatableList() {
  const result = MessageOutgoingSelectors.useGetMessageOutgoingList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');
  const classes = useStyles();

  const ROLE = AuthSelectors.useSelectUserRole();

  const query = useQuery();
  const messageId = query.get('messageId');
  const destinationCountry = query.get('destinationCountry');
  const messageType = query.get('messageType');
  const status = query.get('status');
  const date_from = query.get('date_from');
  const date_to = query.get('date_to');
  let searchParams = {
    ...(messageId && { messageId }),
    ...(destinationCountry && { destinationCountry }),
    ...(messageType && { messageType }),
    ...(status && { status }),
    ...(date_from && { date_from: parseQueryDate(date_from) }),
    ...(date_to && { date_to: parseQueryDate(date_to) }),
  };

  return (
    <Box display="flex" flexDirection="column">
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter
          messageId={messageId}
          destinationCountry={destinationCountry}
          messageType={messageType}
          status={status}
          date_from={parseQueryDate(date_from)}
          date_to={parseQueryDate(date_to)}
          role={ROLE}
        />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            MessageOutgoingActions.fetchMessageOutgoingAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Box>
  );
}

export { ActionsBlock };
